<mat-toolbar style="height: 56px">

    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.gt-xs="space-between center" fxFlex>
        <span class="footer-text">{{footerText}}</span>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxHide fxShow.gt-xs>
        <span class="footer-text">{{versionText}}</span>
    </div>

</mat-toolbar>
